import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { Box, ButtonBase, styled, Typography } from "@material-ui/core";
import {
  ChevronRight,
  History,
  People,
  PlayCircleOutline,
  Tune,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
  EPOCUS_BG,
  EPOCUS_ICON_ACTIVE,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";
import {
  linkToEpocusAuditTrail,
  linkToEpocusManageUsers,
  linkToEpocusOnboarding,
  linkToEpocusProgramConfig,
} from "../../links";
import { SettingsCard } from "./settings-card";

const AdministrationRow = styled(ButtonBase)({
  display: "flex",
  alignItems: "center",
  gap: 12,
  width: "100%",
  textAlign: "left",
  textDecoration: "none",
  color: "inherit",
  padding: 12,
  borderRadius: 8,
  minHeight: 44,
  "&:hover": {
    backgroundColor: EPOCUS_BG,
  },
});

const IconSlot = styled(Box)({
  display: "flex",
  flexShrink: 0,
  color: EPOCUS_ICON_ACTIVE,
});

const TextColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const Spacer = styled(Box)({
  flex: 1,
});

const ChevronSlot = styled(Box)({
  display: "flex",
  flexShrink: 0,
  color: EPOCUS_TEXT_SECONDARY,
});

export const AdministrationSection: FC = () => {
  const [onboardingEnabled] = useFeatureFlag(
    featureFlags.epocus.hackathonSept26,
  );

  return (
    <SettingsCard style={{ gap: 4, padding: 8 }}>
      <AdministrationRow
        // @ts-expect-error -- MUI v4 styled() drops component/to from ButtonBase type
        component={Link}
        to={linkToEpocusManageUsers()}
      >
        <IconSlot>
          <People />
        </IconSlot>
        <TextColumn>
          <Typography style={{ fontSize: rem(15), color: EPOCUS_TEXT_PRIMARY }}>
            Manage users
          </Typography>
          <Typography
            style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}
          >
            Add, edit and manage users in your program
          </Typography>
        </TextColumn>
        <Spacer />
        <ChevronSlot>
          <ChevronRight />
        </ChevronSlot>
      </AdministrationRow>
      <AdministrationRow
        // @ts-expect-error -- MUI v4 styled() drops component/to from ButtonBase type
        component={Link}
        to={linkToEpocusProgramConfig()}
      >
        <IconSlot>
          <Tune />
        </IconSlot>
        <TextColumn>
          <Typography style={{ fontSize: rem(15), color: EPOCUS_TEXT_PRIMARY }}>
            Program configuration
          </Typography>
          <Typography
            style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}
          >
            Choose which exam types your program uses
          </Typography>
        </TextColumn>
        <Spacer />
        <ChevronSlot>
          <ChevronRight />
        </ChevronSlot>
      </AdministrationRow>
      {onboardingEnabled && (
        <AdministrationRow
          // @ts-expect-error -- MUI v4 styled() drops component/to from ButtonBase type
          component={Link}
          to={linkToEpocusOnboarding()}
        >
          <IconSlot>
            <PlayCircleOutline />
          </IconSlot>
          <TextColumn>
            <Typography
              style={{ fontSize: rem(15), color: EPOCUS_TEXT_PRIMARY }}
            >
              Program setup assistant
            </Typography>
            <Typography
              style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}
            >
              Walk through setting up a program step by step
            </Typography>
          </TextColumn>
          <Spacer />
          <ChevronSlot>
            <ChevronRight />
          </ChevronSlot>
        </AdministrationRow>
      )}
      {onboardingEnabled && (
        <AdministrationRow
          // @ts-expect-error -- MUI v4 styled() drops component/to from ButtonBase type
          component={Link}
          to={linkToEpocusAuditTrail()}
        >
          <IconSlot>
            <History />
          </IconSlot>
          <TextColumn>
            <Typography
              style={{ fontSize: rem(15), color: EPOCUS_TEXT_PRIMARY }}
            >
              Activity log
            </Typography>
            <Typography
              style={{ fontSize: rem(12), color: EPOCUS_TEXT_SECONDARY }}
            >
              See what has been changed in your program, and by whom
            </Typography>
          </TextColumn>
          <Spacer />
          <ChevronSlot>
            <ChevronRight />
          </ChevronSlot>
        </AdministrationRow>
      )}
    </SettingsCard>
  );
};
